//=== UqApp builder created on Fri May 19 2023 11:32:54 GMT+0800 (中国标准时间) ===//
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IDXValue, Uq, UqTuid, UqAction, UqSheet, UqQuery, UqMap, UqID, UqIDX, UqIX } from "tonva-react";


//===============================
//======= UQ 百灵威系统工程部/积分商城 ========
//===============================

export enum EnumPointType {
	total = 1,
	point = 2,
	used = 3
}

export enum EnumPointChangingSource {
	ordermultiple = 1,
	signIn = 2,
	exchange = 3,
	order = 5,
	lottery = 8,
	return = 9,
	deduct = 10
}

export enum EnumExchangeState {
	delivering = 12,
	delivered = 13,
	completed = 14,
	canceled = 15
}

export interface TuidProductX {
	id?: number;
	imageUrl: string;
}

export interface Tuid$sheet {
	id?: number;
	no: string;
	user: number;
	date: any;
	sheet: number;
	version: number;
	flow: number;
	app: number;
	state: number;
	discription: string;
	data: string;
	processing: number;
}

export interface TuidCustomer {
	id?: number;
}

export interface TuidWebUser {
	id?: number;
}

export interface TuidContact {
	id?: number;
}

export interface TuidCurrency {
	id?: number;
}

export interface TuidBuyerAccount {
	id?: number;
}

export interface TuidGenre {
	id?: number;
	name: string;
	imageUrl: string;
}

export interface TuidPointProductLib {
	id?: number;
	description: string;
	descriptionC: string;
	grade: string;
	point: number;
	imageUrl: string;
	startDate: any;
	endDate: any;
	isValid: number;
}

export interface TuidBrand {
	id?: number;
}

export interface Tuid$user {
	id?: number;
	name: string;
	nick: string;
	icon: string;
	assigned: string;
	poke: number;
	timezone: number;
}

export interface ParamIsCanUseOrder {
	orderId: string;
	customer: number;
}
export interface ReturnIsCanUseOrderRet {
	result: number;
	id: string;
}
export interface ResultIsCanUseOrder {
	ret: ReturnIsCanUseOrderRet[];
}

export interface ParamAddPlatformOrderPoint {
	orderId: string;
	couponId: string;
	customer: number;
}
export interface ReturnAddPlatformOrderPointRet {
	result: number;
}
export interface ResultAddPlatformOrderPoint {
	ret: ReturnAddPlatformOrderPointRet[];
}

export interface ParamGetLastPlatFormOrder {
	customer: number;
}
export interface ReturnGetLastPlatFormOrderRet {
	result: number;
	platformOrderId: string;
}
export interface ResultGetLastPlatFormOrder {
	ret: ReturnGetLastPlatFormOrderRet[];
}

export interface ParamSignin {
	webuser: number;
	customer: number;
	amount: number;
}
export interface ResultSignin {
}

export interface ParamSetPointProductVisits {
	pointProduct: number;
}
export interface ResultSetPointProductVisits {
}

export interface ParamPointProductGenreDelete {
	genre: number;
}
export interface ResultPointProductGenreDelete {
}

export interface ParamPointChanged {
	customer: number;
	point: number;
	pointYear: number;
	pointType: number;
	pointSource: number;
	comments: string;
}
export interface ResultPointChanged {
}

export interface Param$setMyTimezone {
	_timezone: number;
}
export interface Result$setMyTimezone {
}

export interface Param$role_Unit_Del_Admin {
	unit: number;
	user: number;
	admin: number;
}
export interface Result$role_Unit_Del_Admin {
}

export interface Param$role_Unit_User_Role {
	unit: number;
	user: number;
	action: string;
	role: string;
}
export interface Result$role_Unit_User_Role {
}

export interface Param$role_Unit_Quit_Owner {
	unit: number;
}
export interface Result$role_Unit_Quit_Owner {
}

export interface Param$role_Unit_Add_User {
	unit: number;
	user: number;
	assigned: string;
}
export interface Result$role_Unit_Add_User {
}

export interface Param$role_Unit_Add_Admin {
	unit: number;
	user: number;
	admin: number;
	assigned: string;
}
export interface Result$role_Unit_Add_Admin {
}

export interface SheetPointExchangeSheet {
	customer: number;
	webUser: number;
	amount: number;
	shippingContact: number;
	exchangeItems: {
		product: number;
		point: number;
		quantity: number;
		subAmount: number;
	}[];
}

export interface ParamGetPoints {
	customer: number;
}
export interface ReturnGetPointsRet {
	totalLeftPoint: number;
	effectiveLeftPoint: number;
	usedPoint: number;
	pointYear: number;
}
export interface ResultGetPoints {
	ret: ReturnGetPointsRet[];
}

export interface ParamGetPointProduct {
	startPoint: number;
	endPoint: number;
}
export interface ReturnGetPointProductRet {
	product: number;
	point: number;
	imageUrl: string;
}
export interface ResultGetPointProduct {
	ret: ReturnGetPointProductRet[];
}

export interface ParamGetPlatFormOrder {
	platformOrderId: string;
}
export interface ReturnGetPlatFormOrderRet {
	customer: number;
	orderMaker: number;
	platformOrderId: string;
	description: string;
	descriptionC: string;
	radiox: number;
	radioy: number;
	unit: string;
	quantity: number;
	price: number;
	subAmount: number;
	amount: number;
	currency: number;
	mark: string;
}
export interface ResultGetPlatFormOrder {
	ret: ReturnGetPlatFormOrderRet[];
}

export interface ParamGetOrderDrawable {
	customer: number;
	startDate: any;
}
export interface ReturnGetOrderDrawableRet {
	orderId: string;
	orderMaker: number;
	point: number;
}
export interface ResultGetOrderDrawable {
	ret: ReturnGetOrderDrawableRet[];
}

export interface Param$poked {
}
export interface Return$pokedRet {
	poke: number;
}
export interface Result$poked {
	ret: Return$pokedRet[];
}

export interface ParamGetPointHistory {
	customer: number;
	key: string;
}
export interface ReturnGetPointHistory$page {
	id: number;
	date: any;
	point: number;
	pointYear: number;
	comments: string;
	pointType: number;
	source: number;
}
export interface ResultGetPointHistory {
	$page: ReturnGetPointHistory$page[];
}

export interface ParamCheckIsSignin {
	customer: number;
}
export interface ReturnCheckIsSigninRet {
	result: number;
}
export interface ResultCheckIsSignin {
	ret: ReturnCheckIsSigninRet[];
}

export interface ParamGetPointSigninHistory {
	customer: number;
}
export interface ReturnGetPointSigninHistory$page {
	id: number;
	date: any;
	point: number;
	pointYear: number;
	comments: string;
	pointType: number;
	source: number;
}
export interface ResultGetPointSigninHistory {
	$page: ReturnGetPointSigninHistory$page[];
}

export interface ParamGetNewPointProducts {
}
export interface ReturnGetNewPointProductsRet {
	id: number;
	point: number;
	startDate: any;
	endDate: any;
	imageUrl: string;
}
export interface ResultGetNewPointProducts {
	ret: ReturnGetNewPointProductsRet[];
}

export interface ParamGetHotPointProducts {
}
export interface ReturnGetHotPointProductsRet {
	id: number;
	point: number;
	startDate: any;
	endDate: any;
	imageUrl: string;
}
export interface ResultGetHotPointProducts {
	ret: ReturnGetHotPointProductsRet[];
}

export interface ParamGetPointProductGenre {
	pointProduct: number;
}
export interface ReturnGetPointProductGenreRet {
	pointProduct: number;
	genre: number;
}
export interface ResultGetPointProductGenre {
	ret: ReturnGetPointProductGenreRet[];
}

export interface ParamGetPointDistribution {
	start: number;
	end: number;
	granularity: number;
}
export interface ReturnGetPointDistributionRet {
	subStart: number;
	subEnd: number;
	numbers: number;
}
export interface ResultGetPointDistribution {
	ret: ReturnGetPointDistributionRet[];
}

export interface ParamGetMaxPoints {
}
export interface ReturnGetMaxPointsRet {
	maxPoints: number;
}
export interface ResultGetMaxPoints {
	ret: ReturnGetMaxPointsRet[];
}

export interface ParamGetPointProductBySource {
	sourceId: number;
	type: string;
}
export interface ReturnGetPointProductBySourceRet {
	pointProduct: number;
}
export interface ResultGetPointProductBySource {
	ret: ReturnGetPointProductBySourceRet[];
}

export interface ParamGetVisitPointProducts {
}
export interface ReturnGetVisitPointProducts$page {
	seq: number;
	id: number;
	point: number;
	startDate: any;
	endDate: any;
	imageUrl: string;
	visits: number;
	exchanges: number;
}
export interface ResultGetVisitPointProducts {
	$page: ReturnGetVisitPointProducts$page[];
}

export interface ParamGetPointProductByGenre {
	genre: number;
}
export interface ReturnGetPointProductByGenreRet {
	pointProduct: number;
	genre: number;
	point: number;
	imageUrl: string;
}
export interface ResultGetPointProductByGenre {
	ret: ReturnGetPointProductByGenreRet[];
}

export interface ParamGetPointProductsByPage {
	keyWord: string;
}
export interface ReturnGetPointProductsByPage$page {
	seq: number;
	id: number;
	description: string;
	descriptionC: string;
	grade: string;
	point: number;
	imageUrl: string;
}
export interface ResultGetPointProductsByPage {
	$page: ReturnGetPointProductsByPage$page[];
}

export interface ParamGetBrandMinDiscount {
}
export interface ReturnGetBrandMinDiscount$page {
	seq: number;
	brand: number;
	discount: number;
	isValid: number;
}
export interface ResultGetBrandMinDiscount {
	$page: ReturnGetBrandMinDiscount$page[];
}

export interface ParamSearchExchangeOrders {
	customer: number;
	state: number;
}
export interface ReturnSearchExchangeOrders$page {
	seq: number;
	id: number;
	no: string;
	date: any;
	state: string;
}
export interface ResultSearchExchangeOrders {
	$page: ReturnSearchExchangeOrders$page[];
}

export interface Param$getUnitTime {
}
export interface Return$getUnitTimeRet {
	timezone: number;
	unitTimeZone: number;
	unitBizMonth: number;
	unitBizDate: number;
}
export interface Result$getUnitTime {
	ret: Return$getUnitTimeRet[];
}

export interface Param$role_My {
}
export interface Return$role_MyAdmins {
	id: number;
	unit: number;
	admin: number;
	entity: string;
	assigned: string;
}
export interface Return$role_MyRoles {
	unit: number;
	role: string;
}
export interface Return$role_MyUnitProps {
	unit: number;
	props: string;
}
export interface Result$role_My {
	admins: Return$role_MyAdmins[];
	roles: Return$role_MyRoles[];
	unitProps: Return$role_MyUnitProps[];
}

export interface Param$role_Unit_Users {
	unit: number;
}
export interface Return$role_Unit_UsersUsers {
	id: number;
	user: number;
	admin: number;
	assigned: string;
	name: string;
	nick: string;
	icon: string;
	addBy: number;
}
export interface Return$role_Unit_UsersRoles {
	user: number;
	role: string;
}
export interface Result$role_Unit_Users {
	users: Return$role_Unit_UsersUsers[];
	roles: Return$role_Unit_UsersRoles[];
}

export interface $user {
	id?: number;
	name: string;
	nick: string;
	icon: string;
	assigned: string;
	poke: number;
	timeZone: number;
}

export interface OrderMain {
	id?: number;
	no?: string;
}

export interface OrderDetail {
	id?: number;
	main?: number;
	orderMainNo: string;
	orderDetailNo: string;
	endUser: number;
	createDate: any;
}

export interface ExchangeDetail {
	id?: number;
	main?: number;
	item: number;
	quantity: number;
	point: number;
	subAmount: number;
}

export interface ExchangeMain {
	id?: number;
	no?: string;
	customer: number;
	shippingContact: number;
	amount: number;
	sheetId: number;
	createDate: any;
}

export interface ReceiveMain {
	id?: number;
	createDate: any;
}

export interface ReceiveDetail {
	id?: number;
	main?: number;
	orderDetail: number;
	amount: number;
	createDate: any;
}

export interface $userunit {
	id?: number;
	unit: number;
	user: number;
	admin: number;
	assigned: string;
	addBy: number;
}

export interface PointRegister {
	id?: number;
	point: number;
	createDate: any;
	expiredDate: any;
}

export interface $phrase {
	id?: number;
	name: string;
	caption: string;
}

export interface DxOrderDetail {
	id: number;
	point?: number;
	totalPoint?: number;
	multiple?: number;
	$act?: number;
}

export interface DxReOrderDetail {
	id: number;
	point?: number;
	totalPoint?: number;
	$act?: number;
}

export interface DxExchangeDetail {
	id: number;
	deliver?: number;
	deliverDone?: number;
	deliverTime?: any;
	$act?: number;
}

export interface DxExchangeMainState {
	id: number;
	state?: any;
	createDate?: any;
	$act?: number;
}

export interface DxExchangeDetailState {
	id: number;
	state?: any;
	createDate?: any;
	$act?: number;
}

export interface ActParamDxOrderDetail {
	id: number|IDXValue;
	point?: number|IDXValue;
	totalPoint?: number|IDXValue;
	multiple?: number|IDXValue;
	$act?: number;
}

export interface ActParamDxReOrderDetail {
	id: number|IDXValue;
	point?: number|IDXValue;
	totalPoint?: number|IDXValue;
	$act?: number;
}

export interface ActParamDxExchangeDetail {
	id: number|IDXValue;
	deliver?: number|IDXValue;
	deliverDone?: number|IDXValue;
	deliverTime?: any|IDXValue;
	$act?: number;
}

export interface ActParamDxExchangeMainState {
	id: number|IDXValue;
	state?: any|IDXValue;
	createDate?: any|IDXValue;
	$act?: number;
}

export interface ActParamDxExchangeDetailState {
	id: number|IDXValue;
	state?: any|IDXValue;
	createDate?: any|IDXValue;
	$act?: number;
}

export interface IxExchangeMainUsedPoint {
	ix: number;
	xi: number;
	point: number;
}

export interface ExchangeDetailDeliver {
	ix: number;
	xi: number;
	deliverDone: number;
	deliverTime: any;
}

export interface IxOrderDetailReceive {
	ix: number;
	xi: number;
	receiveAmount: number;
	createDate: any;
}

export interface ParamActs {
	$user?: $user[];
	orderMain?: OrderMain[];
	orderDetail?: OrderDetail[];
	exchangeDetail?: ExchangeDetail[];
	exchangeMain?: ExchangeMain[];
	receiveMain?: ReceiveMain[];
	receiveDetail?: ReceiveDetail[];
	$userunit?: $userunit[];
	pointRegister?: PointRegister[];
	$phrase?: $phrase[];
	dxOrderDetail?: ActParamDxOrderDetail[];
	dxReOrderDetail?: ActParamDxReOrderDetail[];
	dxExchangeDetail?: ActParamDxExchangeDetail[];
	dxExchangeMainState?: ActParamDxExchangeMainState[];
	dxExchangeDetailState?: ActParamDxExchangeDetailState[];
	ixExchangeMainUsedPoint?: IxExchangeMainUsedPoint[];
	exchangeDetailDeliver?: ExchangeDetailDeliver[];
	ixOrderDetailReceive?: IxOrderDetailReceive[];
}


export interface UqExt extends Uq {
	Acts(param:ParamActs): Promise<any>;

	ProductX: UqTuid<TuidProductX>;
	$sheet: UqTuid<Tuid$sheet>;
	Customer: UqTuid<TuidCustomer>;
	WebUser: UqTuid<TuidWebUser>;
	Contact: UqTuid<TuidContact>;
	Currency: UqTuid<TuidCurrency>;
	BuyerAccount: UqTuid<TuidBuyerAccount>;
	Genre: UqTuid<TuidGenre>;
	PointProductLib: UqTuid<TuidPointProductLib>;
	Brand: UqTuid<TuidBrand>;
	IsCanUseOrder: UqAction<ParamIsCanUseOrder, ResultIsCanUseOrder>;
	AddPlatformOrderPoint: UqAction<ParamAddPlatformOrderPoint, ResultAddPlatformOrderPoint>;
	GetLastPlatFormOrder: UqAction<ParamGetLastPlatFormOrder, ResultGetLastPlatFormOrder>;
	Signin: UqAction<ParamSignin, ResultSignin>;
	SetPointProductVisits: UqAction<ParamSetPointProductVisits, ResultSetPointProductVisits>;
	PointProductGenreDelete: UqAction<ParamPointProductGenreDelete, ResultPointProductGenreDelete>;
	PointChanged: UqAction<ParamPointChanged, ResultPointChanged>;
	$setMyTimezone: UqAction<Param$setMyTimezone, Result$setMyTimezone>;
	$role_Unit_Del_Admin: UqAction<Param$role_Unit_Del_Admin, Result$role_Unit_Del_Admin>;
	$role_Unit_User_Role: UqAction<Param$role_Unit_User_Role, Result$role_Unit_User_Role>;
	$role_Unit_Quit_Owner: UqAction<Param$role_Unit_Quit_Owner, Result$role_Unit_Quit_Owner>;
	$role_Unit_Add_User: UqAction<Param$role_Unit_Add_User, Result$role_Unit_Add_User>;
	$role_Unit_Add_Admin: UqAction<Param$role_Unit_Add_Admin, Result$role_Unit_Add_Admin>;
	PointExchangeSheet: UqSheet<SheetPointExchangeSheet, any>;
	GetPoints: UqQuery<ParamGetPoints, ResultGetPoints>;
	GetPointProduct: UqQuery<ParamGetPointProduct, ResultGetPointProduct>;
	GetPlatFormOrder: UqQuery<ParamGetPlatFormOrder, ResultGetPlatFormOrder>;
	GetOrderDrawable: UqQuery<ParamGetOrderDrawable, ResultGetOrderDrawable>;
	$poked: UqQuery<Param$poked, Result$poked>;
	GetPointHistory: UqQuery<ParamGetPointHistory, ResultGetPointHistory>;
	CheckIsSignin: UqQuery<ParamCheckIsSignin, ResultCheckIsSignin>;
	GetPointSigninHistory: UqQuery<ParamGetPointSigninHistory, ResultGetPointSigninHistory>;
	GetNewPointProducts: UqQuery<ParamGetNewPointProducts, ResultGetNewPointProducts>;
	GetHotPointProducts: UqQuery<ParamGetHotPointProducts, ResultGetHotPointProducts>;
	GetPointProductGenre: UqQuery<ParamGetPointProductGenre, ResultGetPointProductGenre>;
	GetPointDistribution: UqQuery<ParamGetPointDistribution, ResultGetPointDistribution>;
	GetMaxPoints: UqQuery<ParamGetMaxPoints, ResultGetMaxPoints>;
	GetPointProductBySource: UqQuery<ParamGetPointProductBySource, ResultGetPointProductBySource>;
	GetVisitPointProducts: UqQuery<ParamGetVisitPointProducts, ResultGetVisitPointProducts>;
	GetPointProductByGenre: UqQuery<ParamGetPointProductByGenre, ResultGetPointProductByGenre>;
	GetPointProductsByPage: UqQuery<ParamGetPointProductsByPage, ResultGetPointProductsByPage>;
	GetBrandMinDiscount: UqQuery<ParamGetBrandMinDiscount, ResultGetBrandMinDiscount>;
	SearchExchangeOrders: UqQuery<ParamSearchExchangeOrders, ResultSearchExchangeOrders>;
	$getUnitTime: UqQuery<Param$getUnitTime, Result$getUnitTime>;
	$role_My: UqQuery<Param$role_My, Result$role_My>;
	$role_Unit_Users: UqQuery<Param$role_Unit_Users, Result$role_Unit_Users>;
	PointProduct: UqMap;
	PlatformOrder: UqMap;
	PlatformOrderUsed: UqMap;
	PointShopOrder: UqMap;
	PointProductGenre: UqMap;
	PointProductSource: UqMap;
	PointProductDetail: UqMap;
	BrandMinDiscount: UqMap;
	OrderBack: UqMap;
	PointCustomerBlacklist: UqMap;
	$user: UqID<any>;
	OrderMain: UqID<any>;
	OrderDetail: UqID<any>;
	ExchangeDetail: UqID<any>;
	ExchangeMain: UqID<any>;
	ReceiveMain: UqID<any>;
	ReceiveDetail: UqID<any>;
	$userunit: UqID<any>;
	PointRegister: UqID<any>;
	$phrase: UqID<any>;
	DxOrderDetail: UqIDX<any>;
	DxReOrderDetail: UqIDX<any>;
	DxExchangeDetail: UqIDX<any>;
	DxExchangeMainState: UqIDX<any>;
	DxExchangeDetailState: UqIDX<any>;
	IxExchangeMainUsedPoint: UqIX<any>;
	ExchangeDetailDeliver: UqIX<any>;
	IxOrderDetailReceive: UqIX<any>;
}

export function assign(uq: any, to:string, from:any): void {
	let hasEntity = uq.$.hasEntity(to);
	if (hasEntity === false) {
		return;
	}
	Object.assign((uq as any)[to], from);
}
